import { render, staticRenderFns } from "./ArchitectsOrderCollection.vue?vue&type=template&id=6be0fd14&"
import script from "./ArchitectsOrderCollection.ts?vue&type=script&lang=ts&"
export * from "./ArchitectsOrderCollection.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports